import moment from "moment";
import {Aux, isNullEmptyOrWhitespace, URGENT_RUN_TAKE_PHOTOS_MESSAGE} from "../../constants";
import React from "react";
import { mustBeArray } from "../../utils/lib";
import { isPickupUrgentForRunType, getRelevantUrgentText } from "../../utils/collectionTypes";

const PickupStatus = (props) => {
    let {pickup, userHasDriverRole, urgentPhotoUploadRequired, run} = props;
    let badge = 'badge badge-danger';
    let icon = 'fa fa-square-o';
    let text = '';
    const runTypeCode = run?.truckCollectionTypeCode;
    const isUrgentForThisRun = isPickupUrgentForRunType(pickup, runTypeCode);
    const urgentText = getRelevantUrgentText(pickup, runTypeCode);

    if (pickup.pickupStatusCode === 'PEN') {
        if (isUrgentForThisRun) {
            badge = 'badge badge-danger';
            icon = 'fa fa-exclamation-triangle fa-2x text-danger';
            text = urgentText;
        } else {
            badge = 'badge badge-warning';
            icon = '';
            text = 'pending';
        }
    } else if (pickup.pickupStatusCode === 'COM') {
        badge = 'badge badge-success';
        icon = 'fa fa-check-square fa-2x text-success';
        text = `${moment(pickup.datePickedUp).format('ddd, Do, LT')}`;
    } else if (pickup.pickupStatusCode === 'CAN') {
        if (isUrgentForThisRun) {
            badge = 'badge badge-default';
            icon = 'fa fa-exclamation-triangle fa-2x text-muted';
            text = pickup.datePickedUp ? `${moment(pickup.datePickedUp).format('ddd, Do, LT')}` : urgentText;
        } else {
            badge = 'badge badge-default';
            icon = 'fa fa-ban fa-2x text-muted';
            text = pickup.datePickedUp ? `${moment(pickup.datePickedUp).format('ddd, Do, LT')}` : 'cancelled';
        }
    }

    if (pickup.addedByDriverUserId !== undefined && pickup.addedByDriverUserId !== null) {
        text = `${text} - added by driver`;
    }

    return (<Aux>
        <h4>
            <span className={badge}>
          {`#${pickup.pickupOrder + 1} ${pickup.locationTypeName} `} <small className="text-muted">{text}</small>
            </span>
            {pickup.hasAnyTankDropOffs && <span>
                <i
                    className={"fa fa-plus-square text-danger ml-1"}
                    data-toggle="tooltip" data-placement="top" title="Has tanks to drop off"
                /><small style={{fontSize:"45%"}}>&nbsp;Drop-off</small>
            </span> }
            {pickup.hasAnyTankPickups && <span>
                <i
                    className={"fa fa-minus-square text-danger ml-1"}
                    data-toggle="tooltip" data-placement="top" title="Has tanks to pick up"
                /><small style={{fontSize:"45%"}}>&nbsp;Pickup</small>
            </span> }
            <span className="pull-right">&nbsp;<i className={icon}/></span>
        </h4>
        {!isNullEmptyOrWhitespace(pickup.cancelReason) && <h5>Cancel Reason: {pickup.cancelReason}</h5>}
        {pickup && isUrgentForThisRun && userHasDriverRole && urgentPhotoUploadRequired &&
         <h6 className=' mb-1 mt-1 text-danger display-5'>{URGENT_RUN_TAKE_PHOTOS_MESSAGE}</h6>}
    </Aux>);
};

export default PickupStatus;